module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo3-6c9b76568c5b17243610495f73d02b3d.jpg";